//@ts-nocheck
import { Route, Routes } from "react-router-dom";
import PageNotFound from "../pages/ErrorPage/PageNotFound";
import DashboardLayout from "../layouts/DashboardLayout";
import PrivateRoute from "./PrivateRoute";
import TemplateList from "../pages/TemplateList";
import EditTemplate from "../pages/EditTemplate";
import Overview from "../pages/Overview";
import { WelcomeRouterService } from "@careinfo/welcome-page-service";
import { getKey } from "../helpers/sessionKey";
import CreateTemplate from "../pages/CreateTemplate";
import ExcelTemplateList from "../pages/ExcelTemplate/ExcelTemplateList";
import CreateExcel from "../pages/ExcelTemplate/CreateExcel";
import EditExcel from "../pages/ExcelTemplate/EditExcel";
import ColumnDefinitionList from "../pages/ColumnDefinition/ColumnDefinitionList";
import CreateColumn from "../pages/ColumnDefinition/CreateColumn";
import EditColumn from "../pages/ColumnDefinition/EditColumn";

const Router = () => {
  const shouldShowWelcome = getKey("shouldShowWelcome");
  return (
    <Routes>
      <Route
        element={
          <PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>
        }
      >
        <Route path="/overview" element={<Overview />} />
        <Route
          path={"/"}
          element={
            shouldShowWelcome === "true" || shouldShowWelcome === null ? (
              <WelcomeRouterService />
            ) : (
              <Overview />
            )
          }
        />
        <Route path="/templatelist" element={<TemplateList />} />
        <Route path="/templatelist/create" element={<CreateTemplate />} />
        <Route path="/templatelist/edit/:id" element={<EditTemplate />} />


        <Route path ="/exceltemplatelist" element={<ExcelTemplateList/>}/>
         <Route path="/exceltemplatelist/create" element={<CreateExcel/>} />
        <Route path="/exceltemplatelist/:slug/edit/:id" element={<EditExcel/>}/>

        <Route path = "/columndefinitionlist" element={<ColumnDefinitionList/>}/>
        <Route path = "/columndefinitionlist/create" element={<CreateColumn/>}/>
        <Route path ="/columndefinitionlist/:slug/edit/:id" element={<EditColumn/>}/>
       



        <Route path="/*" element={<PageNotFound />} />
      </Route>
    </Routes>
  );
};

export default Router;
